export default __webpack_public_path__ + "static/cEgbwuEB-308264e3a02383c89454498720eeda01.svg";